import { render, staticRenderFns } from "./Human.vue?vue&type=template&id=0f869d98&"
import script from "./Human.vue?vue&type=script&lang=js&"
export * from "./Human.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports